/* eslint-disable @typescript-eslint/ban-types */
import { metadata } from 'aurelia-framework';
import { IWidgetMetadata } from './i-widget-metadata';
import { ReportPageLayoutDeviceType } from '../clients/reporting-clients';

export const WIDGET_METADATA_KEY = 'dynamik:widget';

export function widget(nameOrMetadata: string | IWidgetMetadata, canUseInReport?: boolean, canUseInDashboard?: boolean, description?: string, deviceTypes?: ReportPageLayoutDeviceType[]) {
  return function widgetDecorator(target: Function) {
    metadata.getOrCreateOwn(WIDGET_METADATA_KEY, function () {
      return typeof nameOrMetadata === 'string'
        ? {
          name: nameOrMetadata,
          viewModel: target,
          canUseInReport,
          canUseInDashboard,
          description,
          deviceTypes
        } as IWidgetMetadata
        : {
          name: nameOrMetadata.name,
          viewModel: target,
          canUseInReport: nameOrMetadata.canUseInReport,
          canUseInDashboard: nameOrMetadata.canUseInDashboard,
          description: nameOrMetadata.description,
          deviceTypes: nameOrMetadata.deviceTypes,
          defaultWidth: nameOrMetadata.defaultWidth,
          defaultHeight: nameOrMetadata.defaultHeight
        } as IWidgetMetadata;
    }, target);
  };
}
